import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import AntInputNumber from 'antd/es/input-number';

import './InputNumber.scss';

/**
 * Inputs.
 */
export default AntInputNumber;